
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ReasonCode enum
 */
class ReasonCode {
  /**
   * Initialize enum with a given value
   * @param {ReasonCode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ReasonCode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ReasonCode}
   * @param {!ReasonCode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ReasonCode)) {
      throw new TypeError('Instance of ReasonCode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ReasonCode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ReasonCode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ReasonCode.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ReasonCode.CLIENT.value) {
      return 'CLIENT'
    }
    if (this.value === ReasonCode.MANAGER.value) {
      return 'MANAGER'
    }
    if (this.value === ReasonCode.INTERNAL.value) {
      return 'INTERNAL'
    }
    if (this.value === ReasonCode.EXTERNAL.value) {
      return 'EXTERNAL'
    }
    if (this.value === ReasonCode.SOCIAL_TRADING.value) {
      return 'SOCIAL_TRADING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ReasonCode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ReasonCode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ReasonCode} Created enum
   */
  static fromObject (other) {
    return new ReasonCode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ReasonCode.UNKNOWN = new ReasonCode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ReasonCode.CLIENT = new ReasonCode(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ReasonCode.MANAGER = new ReasonCode(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ReasonCode.INTERNAL = new ReasonCode(0 + 3)
// noinspection PointlessArithmeticExpressionJS
ReasonCode.EXTERNAL = new ReasonCode(0 + 4)
// noinspection PointlessArithmeticExpressionJS
ReasonCode.SOCIAL_TRADING = new ReasonCode(0 + 5)

export { ReasonCode };

/**
 * Fast Binary Encoding ReasonCode field model
 */
class FieldModelReasonCode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelReasonCode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelReasonCode}
   * @param {ReasonCode=} defaults Default value, defaults is new ReasonCode()
   * @returns {!ReasonCode} Result value
   */
  get (defaults = new ReasonCode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ReasonCode(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelReasonCode}
   * @param {!ReasonCode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelReasonCode };
